function Loading(message="Loading...") {
    return(<div style={{ marginTop: '30px' }}><img alt={message} src="/images/spinner.gif"/></div>);
}

export default Loading;